import React, { useRef, useState, useEffect } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from 'jquery';
import WhatUsersSayingObj from './WhatUsersSayingObj';
import WhatUsersSayingObjslider2 from './WhatUsersSayingObjslider2';
import ShapeAnimation from '../../ShapeAnimation';
import YoutubeModal from './YoutubeModal3';
import YoutubeModal3 from './YoutubeModal3';
import YouTubeModal2 from './YouTubeModal2';
import YoutubbeModal1 from './YoutubeModal1';
import YoutubeModal1 from './YoutubeModal1';
import YoutubeModal4 from './YouTubeModal4';
import YoutubeModal5 from './YouTubeModal5';
import YoutubeModal6 from './YouTubeModal6';
const WhatUsersSaying = () => {

  // useEffect(() => {
  //   $(document).ready(function () {
  //     $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
  //       disableOn: 700,
  //       type: 'iframe',
  //       mainClass: 'mfp-fade',
  //       removalDelay: 160,
  //       preloader: false,

  //       fixedContentPos: false
  //     });
  //   });
  // }, [])


  // useEffect(() => {
  //   $("#slider").slick("refresh");
  // }, []);
  let [iframe, setIframe] = useState("ddd");
  const modalContentRef = useRef(null);

  // const setDynamicData = (data) => {
  //   console.log('setDynamic Data:::::', modalContentRef);
  //   if (modalContentRef.current) {
  //     modalContentRef.current.textContent = data;
  //   }
  // }

  const iframeLink = useRef();
  // useEffect(() => {
  //   iframeLink.current = ;
  // }, [iframeLink]);
  // console.log(iframe, ":iframe");

  const settings1 = {
    arrows: false,
    nav: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'linear',
    fade: true,
    lazyLoad: true,
    autoplay: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <button className="next-arrow slick-arrow" >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
        </button>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div className={className}
        onClick={onClick}>
        <button className="prev-arrow slick-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
        </button>
      </div>
    );
  }
  // const customeSlider = useState();


  const settings2 = {
    // dots: true,
    // arrows: true,
    nav: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    cssEase: 'linear',
    autoplay: true,
    lazyLoad: true,
    centerMode: true,
    draggable: true,
    focusOnSelect: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  return (
    <div>
      <section className="feedback-area pt-60 pb-60 bg-f7fafd feedback-cus">
        <div className="container">
          <div className="section-title">
            <h2 className='fontkumbh'>What users Saying</h2>
            <div className="bar" />
            <p>
              We love what we do and we do what our clients love &amp; work with great
              clients all over the world to create thoughtful and purposeful websites.
            </p>
          </div>
          <div className="feedback-slides">
            <div className="client-feedback" key={1}>
              <Slider {...settings1} asNavFor={nav2} ref={(slider1) => setNav1(slider1)}>
                {/* {WhatUsersSayingObj.map((wusrepeat) => {
                  return <div className="item" key={wusrepeat.id}>
                    <div className="single-feedback">
                      <div className="client-img">
                        <img src={wusrepeat.img} alt="user" loading="lazy" />

                        {wusrepeat.iframe && <a className="popup-youtube" type="button" data-toggle="modal" data-target={`#ytModal${wusrepeat.id}`} >
                          <img src="./assets/play.webp" className='img-fluid play-icon' alt="" onClick={() => { console.log(wusrepeat.id) }} />

                        </a>}

                      </div>
                      <h3 className="pb-2">{wusrepeat.heading}</h3>
                      <p style={{ display: "inline" }}>
                        <img src={wusrepeat.p1img} loading="lazy" alt="user" style={{ display: "inline", height: 25 }} />
                        {wusrepeat.para}
                        <img src={wusrepeat.p2img} style={{ display: "inline", height: 25 }} alt="user" loading="lazy" />
                      </p>
                    </div>

                  </div>
                }) */}
                < div className="item" key={1} data-index={1}>
                  <div className="single-feedback">
                    <div className="client-img">
                      <img src='assets/img/client-image/luis-muniz.webp' alt="user" loading="lazy" />

                      <a className="popup-youtube" type="button" data-toggle="modal" data-target={`#ytModal1`} >
                        <img src="./assets/play.webp" className='img-fluid play-icon' alt="" />
                      </a>

                    </div>
                    <h3 className="pb-2 fontkumbh">Luis Muniz</h3>
                    <p style={{ display: "inline" }}>
                      <img src="assets/img/q-u.webp" loading="lazy" alt="user" style={{ display: "inline", height: 25 }} />
                      Naveen and his team have done great work for us. They have been very willing to work with us and deliver high-quality results. I expect to have a long working relationship with Alboha Technologies.
                      <img src="assets/img/q-d.webp" style={{ display: "inline", height: 25 }} alt="user" loading="lazy" />
                    </p>
                  </div>
                </div>

                <div className="item" key={2} data-index={2}>
                  <div className="single-feedback">
                    <div className="client-img">
                      <img src='assets/img/client-image/sebestian.webp' alt="user" loading="lazy" />

                      {/* <a className="popup-youtube" type="button" data-toggle="modal" data-target={`#ytModal2`} >
                        <img src="./assets/play.webp" className='img-fluid play-icon' alt="" />
                      </a> */}

                    </div>
                    <h3 className="pb-2 fontkumbh">Sebastian Glanzer</h3>
                    <p style={{ display: "inline" }}>
                      <img src="assets/img/q-u.webp" loading="lazy" alt="user" style={{ display: "inline", height: 25 }} />
                      I am a software developer for 30 years based in Latin America and more over I am a software broker for hundreds of companies in many Spanish speaking countries who need software.
                      <img src="assets/img/q-d.webp" style={{ display: "inline", height: 25 }} alt="user" loading="lazy" />
                    </p>
                  </div>
                </div>


                <div className="item" key={3} data-index={3}>
                  <div className="single-feedback">
                    <div className="client-img">
                      <img src='assets/img/client-image/Joshua-latimer.webp' alt="user" loading="lazy" />

                      {/* <a className="popup-youtube" type="button" data-toggle="modal" data-target={`#ytModal3`} >
                        <img src="./assets/play.webp" className='img-fluid play-icon' alt="" />
                      </a> */}

                    </div>
                    <h3 className="pb-2 fontkumbh">Joshua Latimer</h3>
                    <p style={{ display: "inline" }}>
                      <img src="assets/img/q-u.webp" loading="lazy" alt="user" style={{ display: "inline", height: 25 }} />
                      Great company to work with and the company leadership is great! We have used them for several projects in the past and will be using them more in the future Its hard to find reliable.
                      <img src="assets/img/q-d.webp" style={{ display: "inline", height: 25 }} alt="user" loading="lazy" />
                    </p>
                  </div>
                </div>


                <div className="item" key={4} data-index={4}>
                  <div className="single-feedback">
                    <div className="client-img">
                      <img src='assets/img/client-image/lincoln-birch.webp' alt="user" loading="lazy" />

                      <a className="popup-youtube" type="button" data-toggle="modal" data-target={`#ytModal4`} >
                        <img src="./assets/play.webp" className='img-fluid play-icon' alt="" />
                      </a>

                    </div>
                    <h3 className="pb-2 fontkumbh">Lincoln Birch</h3>
                    <p style={{ display: "inline" }}>
                      <img src="assets/img/q-u.webp" loading="lazy" alt="user" style={{ display: "inline", height: 25 }} />
                      Excellent experience. Very good communication from entire team. Project completed on time. Honest and quick work. Hire them.You did fantastic job. you are perfect for wordpress custom plugin coding.
                      <img src="assets/img/q-d.webp" style={{ display: "inline", height: 25 }} alt="user" loading="lazy" />
                    </p>
                  </div>
                </div>


                <div className="item" key={5} data-index={5}>
                  <div className="single-feedback">
                    <div className="client-img">
                      <img src='assets/img/client-image/Jay-lamothe.webp' alt="user" loading="lazy" />

                      {/* <a className="popup-youtube" type="button" data-toggle="modal" data-target={`#ytModal5`} >
                        <img src="./assets/play.webp" className='img-fluid play-icon' alt="" />
                      </a> */}

                    </div>
                    <h3 className="pb-2 fontkumbh">Jay Lamothe</h3>
                    <p style={{ display: "inline" }}>
                      <img src="assets/img/q-u.webp" loading="lazy" alt="user" style={{ display: "inline", height: 25 }} />
                      Great client to work with,I'd love to work with her again, This job was done fast and for a great price. Excellent work. Thanks!
                      <img src="assets/img/q-d.webp" style={{ display: "inline", height: 25 }} alt="user" loading="lazy" />
                    </p>
                  </div>
                </div>


                <div className="item" key={6} data-index={6}>
                  <div className="single-feedback">
                    <div className="client-img">
                      <img src='assets/img/client-image/ankit-gupta.webp' alt="user" loading="lazy" />

                      {/* <a className="popup-youtube" type="button" data-toggle="modal" data-target={`#ytModal6`} >
                        <img src="./assets/play.webp" className='img-fluid play-icon' alt="" />
                      </a> */}

                    </div>
                    <h3 className="pb-2 fontkumbh">Ankit Gupta</h3>
                    <p style={{ display: "inline" }}>
                      <img src="assets/img/q-u.webp" loading="lazy" alt="user" style={{ display: "inline", height: 25 }} />
                      This job was done fast and for a great price. Excellent work. Thanks!
                      <img src="assets/img/q-d.webp" style={{ display: "inline", height: 25 }} alt="user" loading="lazy" />
                    </p>
                  </div>
                </div>


              </Slider>
            </div>
            <div className="client-thumbnails" key={1}>
              <Slider {...settings2} asNavFor={nav1} ref={(slider2) => setNav2(slider2)} slidesToShow={5} swipeToSlide={true} focusOnSelect={true}>
                {/* {WhatUsersSayingObjslider2.map((wusslider2) => {
                  return <div className="item" key={wusslider2.id}>
                    <div className="img-fill">
                      <img src={wusslider2.img} alt="client" loading="lazy" />
                    </div>
                  </div>
                })} */}

                <div className="item" key={1} data-index={1}>
                  <div className="img-fill">
                    <img src="assets/img/client-image/luis-muniz.webp" alt="client" loading="lazy" />
                  </div>
                </div>

                <div className="item" key={2} data-index={2}>
                  <div className="img-fill">
                    <img src="assets/img/client-image/sebestian.webp" alt="client" loading="lazy" />
                  </div>
                </div>

                <div className="item" key={3} data-index={3}>
                  <div className="img-fill">
                    <img src="assets/img/client-image/Joshua-latimer.webp" alt="client" loading="lazy" />
                  </div>
                </div>

                <div className="item" key={4} data-index={4}>
                  <div className="img-fill">
                    <img src="assets/img/client-image/lincoln-birch.webp" alt="client" loading="lazy" />
                  </div>
                </div>

                <div className="item" key={5} data-index={5}>
                  <div className="img-fill">
                    <img src="assets/img/client-image/Jay-lamothe.webp" alt="client" loading="lazy" />
                  </div>
                </div>

                <div className="item" key={6} data-index={6}>
                  <div className="img-fill">
                    <img src="assets/img/client-image/ankit-gupta.webp" alt="client" loading="lazy" />
                  </div>
                </div>
              </Slider>
            </div>

          </div>
        </div >
        <ShapeAnimation />
      </section >
      <YoutubeModal1 />
      <YouTubeModal2 />
      <YoutubeModal3 />
      <YoutubeModal4 />
      <YoutubeModal5 />
      <YoutubeModal6 />
    </div >

  )
}

export default WhatUsersSaying